// chatbot.js — Widget flottant ByLesAudacieuses
// À coller dans theme.liquid juste avant </body> :
// <script src="{{ 'chatbot.js' | asset_url }}" defer></script>
//
// ⚠️ Remplace VERCEL_URL par l'URL de ton projet Vercel
// ex: https://chatbot-bylesaudacieuses.vercel.app

(function () {
  // ─── Configuration ───────────────────────────────────────────────
  const CONFIG = {
    apiUrl: 'https://chatbot-bylesaudacieuses.vercel.app/api/chat',
    trackClicUrl: 'https://chatbot-bylesaudacieuses.vercel.app/api/track-clic',
    // Remplace par l'URL exacte de ta page Planity
    // ex: https://www.planity.com/by-les-audacieuses-63000-clermont-ferrand
    planityUrl: 'https://www.planity.com/les-audacieuses-63000-clermont-ferrand-wio',
    sousTitre: 'Assistante By Les Audacieuses',
    couleurPrincipale: '#C8A97F',     // doré chaud signature ByLesAudacieuses
    couleurHover: '#C09F71',          // variante sombre pour les hover
    couleurSecondaire: '#000000',     // fond header/nav (noir pur, identique au site)
    couleurTexte: '#ffffff',
    couleurTextePage: '#121212',      // texte principal quasi-noir
    messageAccueil: 'Bonjour ! Tu cherches un bijou ou tu veux te faire percer au salon ? Je peux te guider vers le modele parfait ou reserver ton rendez-vous en quelques secondes !',
    suggestionsInitiales: [
      'Voir nos bestsellers',
      'Prendre rendez-vous',
      'Besoin d\'aide',
    ],
  };

  // ─── Catalogue produits ──────────────────────────────────────────
  // 🔧 Pour vérifier un handle : ouvrir bylesaudacieuses.com/products/[handle]
  //    Si la page existe → handle correct. Sinon → corriger le champ "handle".
  // 🖼️ Les photos sont chargées automatiquement depuis la boutique Shopify.
  const CATALOGUE = {
    // ── NARINE ─────────────────────────────────────────────────────────────
    'passion':        { titre: 'Passion',        cat: 'Piercing narine',    handle: 'piercing-nez-passion-titane',                 bestseller: true  },
    'perfection':     { titre: 'Perfection',     cat: 'Piercing narine',    handle: 'anneau-nima-nez',                             bestseller: true  },
    'eternity':       { titre: 'Eternity',       cat: 'Piercing narine',    handle: 'eternity-piercing-narine-en-titane',          bestseller: false },
    'verite':         { titre: 'Verite',         cat: 'Piercing narine',    handle: 'piercing-nez-verite-titane',                  bestseller: false },
    'murmure':        { titre: 'Murmure',        cat: 'Piercing narine',    handle: 'piercing-nez-murmure-titane',                 bestseller: false },
    'culot':          { titre: 'Culot',          cat: 'Piercing narine',    handle: 'piercing-narine-culot-2-0',                   bestseller: false },
    'charmante':      { titre: 'Charmante',      cat: 'Piercing narine',    handle: 'anneau-nez-charmante',                        bestseller: false },
    'divinite':       { titre: 'Divinite',       cat: 'Piercing narine',    handle: 'piercing-narine-divinite-titane',             bestseller: false },
    'fusion':         { titre: 'Fusion',         cat: 'Piercing narine',    handle: 'piercing-narine-fusion-titane',               bestseller: false },

    // ── CARTILAGE / MULTI-USAGE ────────────────────────────────────────────
    'oser':           { titre: 'Oser',           cat: 'Piercing cartilage', handle: 'piercing-anneau-oser-titane',                 bestseller: true  },
    'irreel':         { titre: 'Irreel',         cat: 'Piercing cartilage', handle: 'barbell-bao',                                bestseller: true  },
    'epicurienne':    { titre: 'Epicurienne',    cat: 'Piercing cartilage', handle: 'anneau-epicurienne-titane',                   bestseller: true  },
    'eden':           { titre: 'Eden',           cat: 'Piercing cartilage', handle: 'piercing-eden-titane',                        bestseller: true  },
    'provocante':     { titre: 'Provocante',     cat: 'Piercing cartilage', handle: 'labret-provocante',                          bestseller: true  },
    'assurance':      { titre: 'Assurance',      cat: 'Piercing cartilage', handle: 'labret-assurance',                           bestseller: true  },
    'soupcon':        { titre: 'Soupcon',        cat: 'Piercing cartilage', handle: 'piercing-soupcon-labret-titane',              bestseller: true  },
    'belie':          { titre: 'Belie',          cat: 'Piercing cartilage', handle: 'piercing-belie-labret-titane',                bestseller: true  },
    'baratin-v2':     { titre: 'Baratin V2',     cat: 'Piercing cartilage', handle: 'baratin-v2-1',                               bestseller: true  },
    'stella':         { titre: 'Stella',         cat: 'Piercing cartilage', handle: 'piercing-stella-titane',                     bestseller: true  },
    'parfaite':       { titre: 'Parfaite',       cat: 'Piercing cartilage', handle: 'piercing-parfaite-titane',                   bestseller: true  },
    'aria':           { titre: 'Aria',           cat: 'Piercing cartilage', handle: 'piercing-arcadia-titane',                    bestseller: true  },
    'avalone':        { titre: 'Avalone',        cat: 'Piercing cartilage', handle: 'piercing-avalone-titane',                    bestseller: true  },
    'insolence':      { titre: 'Insolence',      cat: 'Piercing cartilage', handle: 'anneau-basique-dore-piercing-doreille',      bestseller: false },
    'enigme':         { titre: 'Enigme',         cat: 'Piercing cartilage', handle: 'piercing-labret-enigme-titane',              bestseller: false },
    'indice':         { titre: 'Indice',         cat: 'Piercing cartilage', handle: 'piercing-labret-indice-titane',              bestseller: false },

    // ── ANNEAUX ────────────────────────────────────────────────────────────
    'audacieux':      { titre: 'Audacieux',      cat: 'Anneau piercing',    handle: 'piercing-anneau-audacieux-titane',            bestseller: true  },
    'isis':           { titre: 'Isis',           cat: 'Anneau piercing',    handle: 'isis-anneau-titane',                         bestseller: true  },
    'opulence':       { titre: 'Opulence',       cat: 'Fer a cheval',       handle: 'piercing-fer-a-cheval-opulence-titane',       bestseller: true  },
    'confiance':      { titre: 'Confiance',      cat: 'Anneau piercing',    handle: 'anneau-confiance-titane',                    bestseller: false },
    'force':          { titre: 'Force',          cat: 'Anneau piercing',    handle: 'anneau-force-titane',                        bestseller: false },
    'osmose':         { titre: 'Osmose',         cat: 'Anneau piercing',    handle: 'anneau-osmose-titane',                       bestseller: false },
    'soleil':         { titre: 'Soleil',         cat: 'Anneau piercing',    handle: 'piercing-anneau-soleil',                     bestseller: false },
    'tiare':          { titre: 'Tiare',          cat: 'Anneau piercing',    handle: 'anneaudeface-tiare',                         bestseller: false },

    // ── NOMBRIL ────────────────────────────────────────────────────────────
    'mini-belle':     { titre: 'Mini Belle',     cat: 'Piercing nombril',   handle: 'mini-belly-piercing-petit-nombril',           bestseller: true  },
    'eos':            { titre: 'Eos',            cat: 'Piercing nombril',   handle: 'eos-piercing-nombril',                       bestseller: true  },
    'courage':        { titre: 'Courage',        cat: 'Piercing nombril',   handle: 'piercing-nombril-courage',                   bestseller: true  },
    'ambitieuse':     { titre: 'Ambitieuse',     cat: 'Piercing nombril',   handle: 'piercing-nombril-ambitieuse',                bestseller: false },
    'arcadia':        { titre: 'Arcadia',        cat: 'Piercing nombril',   handle: 'piercing-nombril-arcadia-titane',            bestseller: false },
    'desinvolte':     { titre: 'Desinvolte',     cat: 'Piercing nombril',   handle: 'piericng-nombril-desinvolte',                bestseller: false },

    // ── TETON ──────────────────────────────────────────────────────────────
    'cybele':         { titre: 'Cybele',         cat: 'Piercing teton',     handle: 'piercing-teton-cybele-titane',               bestseller: true  },
    'implant':        { titre: 'Implant',        cat: 'Piercing teton',     handle: 'piercing-teton-implant-1',                   bestseller: false },
    'franche':        { titre: 'Franche',        cat: 'Piercing teton',     handle: 'piercing-teton-franche-titane',              bestseller: false },
    'princesse':      { titre: 'Princesse',      cat: 'Piercing teton',     handle: 'piercing-teton-princesse',                   bestseller: false },
    'royal':          { titre: 'Royal',          cat: 'Piercing teton',     handle: 'piercing-teton-royal',                       bestseller: false },

    // ── ROOK ───────────────────────────────────────────────────────────────
    'aurora':         { titre: 'Aurora',         cat: 'Piercing rook',      handle: 'piercing-aurora-pour-le-rook',               bestseller: false },
    'joueuse':        { titre: 'Joueuse',        cat: 'Piercing rook',      handle: 'piercing-joueuse-pour-le-rook',              bestseller: false },
    'cache':          { titre: 'Cache',          cat: 'Piercing rook',      handle: 'piercing-rook-cache-en-titane',              bestseller: false },
    'debrouillarde':  { titre: 'Debrouillarde',  cat: 'Piercing rook',      handle: 'piercing-rook-debrouillarde',                bestseller: false },
    'royaume':        { titre: 'Royaume',        cat: 'Piercing rook',      handle: 'piercing-rook-royaume',                      bestseller: false },
    'ruse':           { titre: 'Ruse',           cat: 'Piercing rook',      handle: 'micro-banane-ruse',                          bestseller: false },

    // ── BOUCLES / FAUX PIERCINGS ───────────────────────────────────────────
    'ceruse':         { titre: 'Ceruse',         cat: 'Boucle + faux piercing', handle: 'boucle-doreille-ceruse',                 bestseller: true  },
    'discrete':       { titre: 'Discrete',       cat: 'Boucle pendante',    handle: 'boucle-doreille-subtile',                    bestseller: true  },
    'inattendu':      { titre: 'Inattendu',      cat: 'Earcuff',            handle: 'faux-piercing-inattendu',                    bestseller: false },
    'renversante':    { titre: 'Renversante',    cat: 'Earcuff',            handle: 'faux-piercing-renversante',                  bestseller: false },

    // ── ACCESSOIRES ────────────────────────────────────────────────────────
    'pince-a-labret':      { titre: 'Pince a labret',               cat: 'Accessoire', handle: 'pince-labret',                       bestseller: true  },
    'guide-tige-courbee':  { titre: 'Guide tige courbee',           cat: 'Accessoire', handle: 'guide-dinsertion-piercing',          bestseller: true  },
    'guide-tige-droite':   { titre: 'Guide tige droite',            cat: 'Accessoire', handle: 'guide-dinsertion-piercing-pour-piercing-nbsp-copie', bestseller: true  },
    'disque-silicone':     { titre: 'Disque silicone',              cat: 'Accessoire', handle: 'disque-en-silicone',                 bestseller: true  },
    'kit-pinces-guide':    { titre: 'Kit Pinces et Guide',          cat: 'Accessoire', handle: 'kit-pinces-et-guide',                bestseller: true  },

    // ── TOP VENTES RÉELS (analyse EasyScan 1 an) ───────────────────────────
    'insaisissable':   { titre: 'Insaisissable',   cat: 'Anneau piercing',      handle: 'anneau-force-insaisissable',              bestseller: true  },
    'ardente':         { titre: 'Ardente',         cat: 'Boucle puce',          handle: 'boucle-doreille-ardente',                 bestseller: true  },
    'attitude':        { titre: 'Attitude',        cat: 'Piercing narine',      handle: 'piercing-nez-attitude-titane',            bestseller: true  },
    'aurorale':        { titre: 'Aurorale',        cat: 'Boucle pendante',      handle: 'boucle-doreille-aurorale',                bestseller: true  },
    'carte-cadeau':    { titre: 'Carte cadeau',    cat: 'Cadeau',               handle: 'carte-cadeau-noel-by-les-audacieuses',    bestseller: false },
    'sirius':          { titre: 'Sirius',          cat: 'Piercing labret',      handle: 'piercing-oreille-labret-sirius',          bestseller: true  },
    'hecate':          { titre: 'Hécate',          cat: 'Boucle anneau',        handle: 'boucle-doreille-hecate',                  bestseller: true  },
    'cristal':         { titre: 'Cristal',         cat: 'Boucle pendante',      handle: 'creole-cristal',                          bestseller: true  },
    'heritier':        { titre: 'Héritier',        cat: 'Anneau piercing',      handle: 'piercing-anneau-heritier',                bestseller: true  },
    'cran':            { titre: 'Cran',            cat: 'Anneau cartilage',     handle: 'anneau-cran',                             bestseller: true  },
    'narine-modele':   { titre: 'Narine Modèle',  cat: 'Piercing narine',      handle: 'piercing-narine-modele-2-0',              bestseller: true  },
    'lumiere':         { titre: 'Lumière',         cat: 'Piercing narine',      handle: 'piercing-narine-lumiere-titane',          bestseller: false },
    'naga':            { titre: 'Naga',            cat: 'Anneau piercing',      handle: 'anneau-naga-titane',                      bestseller: false },
    'perle':           { titre: 'Perle',           cat: 'Boucle double',        handle: 'boucle-doreille-perle',                   bestseller: false },
    'elysia':          { titre: 'Élysia',          cat: 'Piercing industriel',  handle: 'elysia-piercing-industriel',              bestseller: false },
  };

  // ─── Réponses preset (suggestions vedettes, sans appel API) ─────────
  // Quand la cliente clique sur une suggestion vedette, on affiche directement
  // les produits sans passer par l'IA — plus rapide et toujours cohérent.
  const REPONSES_PRESET = {
    'Voir nos bestsellers':
      'Ceux que toutes les audacieuses portent en ce moment :\n{{PRODUIT:perfection}}\n{{PRODUIT:sirius}}\n{{PRODUIT:heritier}}\n{{PRODUIT:ardente}}\n{{PRODUIT:narine-modele}}',

    'Cadeau':
      'Voici de belles idees cadeau pour toutes les occasions :\n{{PRODUIT:hecate}}\n{{PRODUIT:cristal}}\n{{PRODUIT:aurorale}}\n{{PRODUIT:perle}}\n{{PRODUIT:carte-cadeau}}',

    'Quel bijou pour moi ?':
      'Dis-moi ou tu veux te faire percer ! En attendant voici une selection pour tous les emplacements :\n{{PRODUIT:attitude}}\n{{PRODUIT:assurance}}\n{{PRODUIT:courage}}\n{{PRODUIT:cran}}\n{{PRODUIT:inattendu}}',

    'Je veux craquer 🧡':
      'Voici une selection que tu vas adorer — clique sur "Je le veux" pour l\'ajouter direct au panier ! 🛒\n{{PRODUIT:perfection}}\n{{PRODUIT:sirius}}\n{{PRODUIT:ardente}}\n{{PRODUIT:oser}}\n{{PRODUIT:passion}}\n{{PRODUIT:heritier}}',

    'Besoin d\'aide':
      'Je suis là pour t\'aider 💛 Dis-moi en quelques mots ce qui se passe, ou choisis une option ci-dessous :',

    // ── Réponses SAV fixes (jamais générées par l'IA) ──────────────────
    // But : garantir une réponse complète, identique à chaque fois, sans
    // risque de troncature, d'erreur IA, ni de suggestion de RDV Planity.
    'Retour / échange':
      'Pour organiser le retour de ton bijou, renvoie-le en lettre suivie à l\'adresse suivante (numéro de suivi obligatoire pour tout remboursement en cas de non-réception) :\n\nLes Audacieuses\n29 Avenue du Stade\n63200 RIOM\nFRANCE\n\n📦 À l\'intérieur de ton colis, glisse une petite note avec :\n1. Le n° de ta commande (#BLA...)\n2. Ton nom et prénom\n3. Si tu souhaites un échange ou un remboursement\n4. Le nom de l\'article que tu souhaites recevoir en remplacement (si échange)\n\n⚠️ Important : bien protéger les bijoux lors du retour pour éviter qu\'ils ne soient abîmés pendant le transport. Si les bijoux ne sont pas correctement emballés et arrivent endommagés, le remboursement ne pourra pas être effectué.\n\nEt après ? Dès qu\'on reçoit ton colis, on s\'occupe de tout et on te tient au courant 💛\n\nDélai légal : 14 jours après réception pour se rétracter + 14 jours pour renvoyer. Produits de soins ouverts et cartes cadeaux non remboursables. Frais de retour à la charge de la cliente (sauf erreur boutique).',

    'Bijou défectueux ou cassé':
      'Nous sommes vraiment désolées que tu aies rencontré un problème avec ton bijou 💛\n\nPour qu\'on puisse s\'en occuper au plus vite, envoie-nous à contact@bylesaudacieuses.com :\n1. Une photo ou une vidéo du bijou défectueux\n2. Ton numéro de commande (#BLA...) ou ton nom et prénom\n\nNous te répondrons dans les meilleurs délais !',

    'Autre problème':
      'Décris-nous ta problématique par mail à contact@bylesaudacieuses.com, en précisant :\n1. Ton numéro de commande\n2. Ton nom et prénom\n3. Ton adresse email\n4. Une description précise de ton problème\n\nL\'équipe te répondra rapidement 💛',
  };

  // ─── Sous-suggestions affichées après certains presets (qualification) ────
  // Ex : après avoir cliqué sur "Besoin d'aide", on propose des catégories
  // précises. "Retour / échange", "Bijou défectueux ou cassé" et "Autre
  // problème" sont des réponses fixes (voir REPONSES_PRESET ci-dessus).
  // Seul "Suivi de ma commande" passe par l'IA (recherche de commande réelle).
  const SUGGESTIONS_APRES_PRESET = {
    'Besoin d\'aide': [
      'Retour / échange',
      'Suivi de ma commande',
      'Bijou défectueux ou cassé',
      'Autre problème',
    ],
  };

  // ─── Cache données produits (image + prix) ────────────────────────
  const _produitCache = {};

  // Récupère image et prix via l'API publique Shopify (même domaine)
  async function fetchProduitInfo(handle) {
    if (_produitCache[handle] !== undefined) return _produitCache[handle];
    try {
      const r = await fetch('/products/' + handle + '.js');
      if (!r.ok) { _produitCache[handle] = null; return null; }
      const d = await r.json();
      const info = {
        image: d.featured_image ? 'https:' + d.featured_image : null,
        prix: d.price ? Math.floor(d.price / 100) + ' €' : null,
        variantId: d.variants && d.variants[0] ? d.variants[0].id : null,
      };
      _produitCache[handle] = info;
      return info;
    } catch {
      _produitCache[handle] = null;
      return null;
    }
  }

  // ─── Parsing du texte bot pour détecter les marqueurs produits et Planity ───
  // Retourne un tableau de segments : { type: 'text'|'produit'|'planity', content|cle }
  function parseContenuMessage(texte) {
    const regex = /\{\{PRODUIT:([a-z0-9-]+)\}\}|\{\{PLANITY_RDV\}\}/g;
    const segments = [];
    let lastIndex = 0;
    let match;
    while ((match = regex.exec(texte)) !== null) {
      if (match.index > lastIndex) {
        segments.push({ type: 'text', content: texte.slice(lastIndex, match.index) });
      }
      if (match[0].startsWith('{{PRODUIT:')) {
        segments.push({ type: 'produit', cle: match[1] });
      } else {
        segments.push({ type: 'planity' });
      }
      lastIndex = match.index + match[0].length;
    }
    if (lastIndex < texte.length) {
      segments.push({ type: 'text', content: texte.slice(lastIndex) });
    }
    return segments;
  }

  // ─── Création d'un élément carte produit ─────────────────────────
  function creerCarteElement(cle) {
    const prod = CATALOGUE[cle];
    const el = document.createElement('a');
    el.className = 'bla-card';
    // ref=chatbot&produit=clé : repère technique (pas une donnée personnelle)
    // qui permet de relier un futur panier/achat à cette recommandation —
    // voir detecterEtTaguerPanier() ci-dessous.
    el.href = 'https://bylesaudacieuses.com/products/' + prod.handle + '?ref=chatbot&produit=' + cle;
    el.target = '_blank';
    el.rel = 'noopener noreferrer';
    el.setAttribute('aria-label', 'Voir ' + prod.titre + ' sur la boutique');

    const imgWrapper = document.createElement('div');
    imgWrapper.className = 'bla-card-img-wrapper';

    const placeholder = document.createElement('div');
    placeholder.className = 'bla-card-img-placeholder';
    placeholder.innerHTML = '💛';
    imgWrapper.appendChild(placeholder);
    el.appendChild(imgWrapper);

    const info = document.createElement('div');
    info.className = 'bla-card-info';
    info.innerHTML =
      (prod.bestseller ? '<span class="bla-card-badge">⭐ Bestseller</span>' : '') +
      '<div class="bla-card-titre">' + prod.titre + '</div>' +
      '<div class="bla-card-cat">' + prod.cat + '</div>' +
      '<div class="bla-card-prix"></div>' +
      '<span class="bla-card-btn">Je le veux 💛</span>';
    el.appendChild(info);

    // Chargement image + prix en arrière-plan
    fetchProduitInfo(prod.handle).then(function (data) {
      if (data && data.image) {
        const img = document.createElement('img');
        img.src = data.image;
        img.alt = prod.titre;
        img.className = 'bla-card-img';
        img.loading = 'lazy';
        imgWrapper.replaceChild(img, placeholder);
      }
      if (data && data.prix) {
        const prixEl = el.querySelector('.bla-card-prix');
        if (prixEl) prixEl.textContent = data.prix;
      }
      // Câbler le bouton "Ajouter au panier" direct si variantId disponible
      if (data && data.variantId) {
        const btn = el.querySelector('.bla-card-btn');
        if (btn) {
          btn.addEventListener('click', function (e) {
            // Ajout au panier direct uniquement sur vrai appareil tactile (smartphone/tablette)
            var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
            if (isTouchDevice) {
              e.preventDefault();
              e.stopPropagation();
              ajouterAuPanier(cle, data.variantId, btn);
            }
            // Desktop souris : le lien <a> navigue vers la page produit normalement
          });
        }
      }
    });

    // Tracking du clic — mesure le taux de clic avant achat (complète le
    // suivi panier/achat des webhooks Shopify). Échec silencieux.
    el.addEventListener('click', function () {
      trackerClic('produit', cle);
    });

    return el;
  }

  // ─── Tracking des clics (carte produit + bouton Planity) ─────────
  // RGPD : seules la catégorie fixe + la clé produit (liste fixe) ou "planity"
  // sont transmises. Jamais d'IP, de nom, d'email ou de texte libre.
  // Échec silencieux : ne doit jamais bloquer la navigation.
  function trackerClic(type, cle) {
    if (!CONFIG.trackClicUrl || CONFIG.trackClicUrl.includes('REMPLACER')) return;
    const body = type === 'produit' ? { type: 'produit', cle } : { type: 'planity' };
    fetch(CONFIG.trackClicUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).catch(function () {});
  }

  // ─── Création d'un bouton Planity RDV ────────────────────────────
  function creerBoutonPlanity() {
    const planityUrlAvecUtm = CONFIG.planityUrl !== 'REMPLACER_PAR_URL_PLANITY'
      ? CONFIG.planityUrl + (CONFIG.planityUrl.includes('?') ? '&' : '?') + 'utm_source=chatbot&utm_medium=chat&utm_campaign=rdv_salon'
      : 'https://www.planity.com';

    const el = document.createElement('a');
    el.className = 'bla-planity-btn';
    el.href = planityUrlAvecUtm;
    el.target = '_blank';
    el.rel = 'noopener noreferrer';
    el.setAttribute('aria-label', 'Réserver un rendez-vous sur Planity');
    el.innerHTML = '📅 Réserver un rendez-vous';

    el.addEventListener('click', function () {
      trackerClic('planity');
    });

    return el;
  }

  // ─── Historique de conversation ──────────────────────────────────
  let historique = [];
  let estOuvert = false;
  let enAttente = false;

  // ─── Suivi achats/paniers : taguer le panier Shopify quand une cliente
  // arrive depuis une recommandation du chatbot ──────────────────────
  // RGPD : on ne pose qu'un attribut de panier "chatbot_produit" dont la
  // valeur est une clé produit fixe (ex: "passion"), vérifiée contre le
  // CATALOGUE ci-dessus avant envoi. Aucun email, nom, IP ou texte libre
  // n'est jamais lu ni transmis. Cet attribut est ensuite lu, côté serveur,
  // par les webhooks Shopify (api/webhook-checkout-created.js et
  // api/webhook-order-created.js) pour relier panier/achat à la
  // recommandation, sans aucun identifiant personnel.
  function detecterEtTaguerPanier() {
    try {
      const params = new URLSearchParams(window.location.search);
      if (params.get('ref') !== 'chatbot') return;

      const cle = params.get('produit');
      if (!cle || !CATALOGUE[cle]) return; // valeur hors liste fixe → ignorée

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { chatbot_produit: cle } }),
      }).catch(function () {
        // Échec silencieux : ne doit jamais impacter la navigation
      });
    } catch {
      // Échec silencieux
    }
  }
  detecterEtTaguerPanier();

  // ─── Ajout au panier direct depuis le chatbot ────────────────────
  // Appelle /cart/add.js puis /cart/update.js pour taguer le panier.
  // Aucune navigation : la cliente reste dans le chatbot.
  function ajouterAuPanier(cle, variantId, btn) {
    btn.textContent = '…';
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.75';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (errJson) {
            var msg = (errJson && errJson.description) ? errJson.description : 'Erreur Shopify ' + r.status;
            console.warn('[Chatbot] cart/add.js error:', msg, errJson);
            throw new Error(msg);
          });
        }
        // Taguer le panier pour le suivi chatbot (même logique que detecterEtTaguerPanier)
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { chatbot_produit: cle } }),
        });
      })
      .then(function () {
        // Succès — mettre le bouton en état "ajouté"
        btn.textContent = '✓ Dans le panier !';
        btn.classList.add('bla-card-btn--added');
        btn.style.opacity = '';

        // Message bot avec lien vers le checkout
        var msgDiv = document.createElement('div');
        msgDiv.className = 'bla-msg bot';
        var bubble = document.createElement('div');
        bubble.className = 'bla-bubble';
        bubble.textContent = "C'est dans le panier ! 🛒";
        var lienCheckout = document.createElement('a');
        lienCheckout.href = 'https://bylesaudacieuses.com/checkout';
        lienCheckout.textContent = 'Finaliser ma commande →';
        lienCheckout.target = '_blank';
        lienCheckout.rel = 'noopener noreferrer';
        lienCheckout.className = 'bla-checkout-lien';
        msgDiv.appendChild(bubble);
        msgDiv.appendChild(lienCheckout);
        var msgs = document.getElementById('bla-messages');
        if (msgs) { msgs.appendChild(msgDiv); msgs.scrollTop = msgs.scrollHeight; }
      })
      .catch(function (err) {
        btn.textContent = 'Je le veux 💛';
        btn.style.pointerEvents = '';
        btn.style.opacity = '';
        // Message d'erreur visible dans le chat pour déboguer
        var msgs = document.getElementById('bla-messages');
        if (msgs) {
          var errDiv = document.createElement('div');
          errDiv.className = 'bla-msg bot';
          var errBubble = document.createElement('div');
          errBubble.className = 'bla-bubble';
          errBubble.textContent = 'Oups ! ' + (err && err.message ? err.message : 'Essaie depuis la fiche produit.');
          errDiv.appendChild(errBubble);
          msgs.appendChild(errDiv);
          msgs.scrollTop = msgs.scrollHeight;
        }
      });
  }

  // ─── Chargement police Jost (identique au site) ─────────────────
  if (!document.getElementById('bla-jost-font')) {
    const fontLink = document.createElement('link');
    fontLink.id = 'bla-jost-font';
    fontLink.rel = 'stylesheet';
    fontLink.href = 'https://fonts.googleapis.com/css2?family=Jost:wght@300;400;500;600&display=swap';
    document.head.appendChild(fontLink);
  }

  // ─── Injection du CSS ────────────────────────────────────────────
  const style = document.createElement('style');
  style.textContent = `
    #bla-chatbot * {
      box-sizing: border-box;
      font-family: 'Jost', -apple-system, BlinkMacSystemFont, sans-serif;
    }

    /* Bouton flottant */
    #bla-toggle {
      position: fixed; bottom: 24px; right: 24px; z-index: 9999;
      width: 60px; height: 60px; border-radius: 50%;
      background: ${CONFIG.couleurPrincipale}; border: none; cursor: pointer;
      box-shadow: 0 4px 20px rgba(200,169,127,0.45);
      display: flex; align-items: center; justify-content: center;
      transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
    }
    #bla-toggle:hover { transform: scale(1.08); background: ${CONFIG.couleurHover}; box-shadow: 0 6px 28px rgba(200,169,127,0.55); }
    #bla-toggle svg { width: 28px; height: 28px; fill: #fff; transition: opacity 0.2s; }

    /* Badge non-lu */
    #bla-badge {
      position: absolute; top: -4px; right: -4px;
      background: #e74c3c; color: #fff; font-size: 11px; font-weight: 600;
      width: 20px; height: 20px; border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      display: none;
    }

    /* Fenêtre de chat */
    #bla-window {
      position: fixed; bottom: 96px; right: 24px; z-index: 9998;
      width: 370px; max-width: calc(100vw - 48px);
      height: 530px; max-height: calc(100vh - 120px);
      background: #FAFAFA; border-radius: 18px;
      box-shadow: 0 10px 48px rgba(0,0,0,0.15);
      display: flex; flex-direction: column; overflow: hidden;
      transform: scale(0.85) translateY(20px); opacity: 0;
      pointer-events: none;
      transition: transform 0.25s ease, opacity 0.25s ease;
    }
    #bla-window.ouvert {
      transform: scale(1) translateY(0); opacity: 1; pointer-events: all;
    }

    /* En-tête */
    #bla-header {
      background: ${CONFIG.couleurSecondaire}; color: ${CONFIG.couleurTexte};
      padding: 14px 18px; display: flex; align-items: center; gap: 11px;
      flex-shrink: 0;
    }
    #bla-avatar {
      width: 90px; height: 36px;
      background: transparent;
      display: flex; align-items: center; justify-content: center;
      flex-shrink: 0; overflow: hidden;
    }
    #bla-avatar img { max-width: 100%; max-height: 100%; object-fit: contain; }
    #bla-header-info { flex: 1; }
    #bla-header-info strong { display: block; font-size: 15px; font-weight: 600; letter-spacing: 0.2px; }
    #bla-header-info span { font-size: 11px; opacity: 0.55; font-weight: 300; letter-spacing: 0.5px; }
    #bla-close {
      background: none; border: none; color: #fff; cursor: pointer;
      font-size: 19px; opacity: 0.6; padding: 4px; line-height: 1;
    }
    #bla-close:hover { opacity: 1; }

    /* Zone de messages */
    #bla-messages {
      flex: 1; overflow-y: auto; padding: 18px 16px;
      display: flex; flex-direction: column; gap: 10px;
      scroll-behavior: smooth; background: #FAFAFA;
    }
    #bla-messages::-webkit-scrollbar { width: 3px; }
    #bla-messages::-webkit-scrollbar-thumb { background: #e0e0e0; border-radius: 4px; }

    /* Bulles de message — padding en px fixe, indépendant de la police */
    .bla-msg { display: flex; gap: 8px; max-width: 90%; }
    .bla-msg.user { align-self: flex-end; flex-direction: row-reverse; max-width: 82%; }
    .bla-msg.bot  { align-self: flex-start; flex-direction: column; }

    .bla-bubble {
      padding: 13px 18px;        /* ← px fixes : ne changent PAS si on touche font-size */
      border-radius: 20px;
      font-size: 14px;           /* ← px fixes : indépendant du padding */
      font-weight: 400;
      line-height: 1.6;
      word-wrap: break-word;
      letter-spacing: 0.1px;
    }
    .bla-msg.bot .bla-bubble {
      background: #fff;
      color: ${CONFIG.couleurTextePage};
      border-bottom-left-radius: 5px;
      box-shadow: 0 1px 6px rgba(0,0,0,0.06);
    }
    .bla-msg.user .bla-bubble {
      background: ${CONFIG.couleurPrincipale};
      color: #fff;
      border-bottom-right-radius: 5px;
    }

    /* Animation de saisie */
    .bla-typing .bla-bubble {
      background: #fff;
      padding: 15px 20px;
      box-shadow: 0 1px 6px rgba(0,0,0,0.06);
    }
    .bla-dots { display: flex; gap: 5px; align-items: center; }
    .bla-dots span {
      width: 6px; height: 6px; border-radius: 50%;
      background: #bbb; animation: bla-dot 1.2s infinite;
    }
    .bla-dots span:nth-child(2) { animation-delay: 0.2s; }
    .bla-dots span:nth-child(3) { animation-delay: 0.4s; }
    @keyframes bla-dot {
      0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
      40% { transform: scale(1); opacity: 1; }
    }

    /* ── Carrousel de cartes produits ─────────────────────────────── */
    .bla-cards-row {
      display: flex;
      flex-direction: row;
      gap: 10px;
      overflow-x: auto;
      padding: 4px 2px 10px;
      scroll-snap-type: x mandatory;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: none;
      margin-top: 8px;
    }
    .bla-cards-row::-webkit-scrollbar { display: none; }
    .bla-card {
      display: block;
      flex-shrink: 0;
      scroll-snap-align: start;
      background: #fff;
      border-radius: 14px;
      overflow: hidden;
      box-shadow: 0 2px 10px rgba(0,0,0,0.08);
      border: 1px solid #f0ece6;
      width: 175px;
      text-decoration: none;
      color: inherit;
      transition: transform 0.2s ease, box-shadow 0.2s ease;
      cursor: pointer;
    }
    .bla-card:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(200,169,127,0.22);
      text-decoration: none;
    }
    .bla-card-img-wrapper {
      width: 100%; height: 160px;
      background: #f5f0ea;
      overflow: hidden;
      display: flex; align-items: center; justify-content: center;
    }
    .bla-card-img {
      width: 100%; height: 100%;
      object-fit: cover; display: block;
    }
    .bla-card-img-placeholder {
      font-size: 36px; opacity: 0.4;
    }
    .bla-card-info {
      padding: 11px 13px 13px;
    }
    .bla-card-badge {
      font-size: 10px; font-weight: 600;
      color: ${CONFIG.couleurPrincipale};
      display: block; margin-bottom: 4px;
      text-transform: uppercase; letter-spacing: 0.6px;
    }
    .bla-card-titre {
      font-weight: 600; font-size: 14px;
      color: #121212; margin-bottom: 2px;
      line-height: 1.3;
    }
    .bla-card-cat {
      font-size: 11px; color: #999;
      margin-bottom: 4px; font-weight: 400;
    }
    .bla-card-prix {
      font-size: 15px; font-weight: 600;
      color: #121212; margin-bottom: 8px;
      min-height: 20px;
    }
    .bla-card-btn {
      display: inline-block;
      background: ${CONFIG.couleurPrincipale};
      color: #fff;
      padding: 6px 13px;
      border-radius: 100px;
      font-size: 12px; font-weight: 500;
      letter-spacing: 0.2px;
      text-decoration: none;
      transition: background 0.2s;
    }
    .bla-card:hover .bla-card-btn { background: ${CONFIG.couleurHover}; }
    .bla-card-btn--added {
      background: #2a7a3a !important;
      cursor: default;
    }
    /* Lien "Finaliser ma commande" affiché dans le chat après ajout panier */
    .bla-checkout-lien {
      display: block;
      margin-top: 8px;
      background: #121212;
      color: #fff;
      text-align: center;
      padding: 11px 16px;
      border-radius: 100px;
      font-weight: 600;
      font-size: 13px;
      text-decoration: none;
      transition: background 0.2s;
    }
    .bla-checkout-lien:hover { background: #444; }

    /* ── Bouton Planity RDV ─────────────────────────────────────── */
    .bla-planity-btn {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      margin-top: 10px;
      background: ${CONFIG.couleurSecondaire};
      color: #fff;
      padding: 10px 18px;
      border-radius: 100px;
      font-size: 13px;
      font-weight: 500;
      font-family: 'Jost', sans-serif;
      letter-spacing: 0.3px;
      text-decoration: none;
      transition: background 0.2s, opacity 0.2s;
      box-shadow: 0 2px 10px rgba(0,0,0,0.18);
      cursor: pointer;
    }
    .bla-planity-btn:hover {
      background: #1a1a1a;
      opacity: 0.92;
      text-decoration: none;
    }

    /* Pills de suggestion */
    #bla-suggestions {
      padding: 6px 16px 12px;
      display: flex; flex-wrap: wrap; gap: 7px;
      background: #FAFAFA;
    }
    .bla-suggestion {
      background: transparent;
      border: 1px solid rgba(200,169,127,0.55);
      color: #7a6040;
      padding: 7px 14px;
      border-radius: 100px;
      font-size: 12.5px;
      font-weight: 500;
      font-family: 'Jost', sans-serif;
      letter-spacing: 0.2px;
      cursor: pointer;
      transition: background 0.18s, color 0.18s, border-color 0.18s;
      white-space: nowrap;
    }
    .bla-suggestion:hover {
      background: ${CONFIG.couleurPrincipale};
      color: #fff;
      border-color: ${CONFIG.couleurPrincipale};
    }

    /* Zone de saisie */
    #bla-input-zone {
      padding: 10px 14px 12px; border-top: 1px solid #f0ece6;
      display: flex; gap: 8px; align-items: flex-end;
      background: #fff;
    }
    #bla-input {
      flex: 1; border: 1.5px solid #ece8e2; border-radius: 22px;
      padding: 10px 16px; font-size: 14px; resize: none;
      max-height: 100px; outline: none; line-height: 1.5;
      transition: border-color 0.2s; background: #FAFAFA;
      font-family: 'Jost', sans-serif; font-weight: 400;
      color: ${CONFIG.couleurTextePage};
    }
    #bla-input::placeholder { color: #bbb; font-weight: 300; }
    #bla-input:focus { border-color: ${CONFIG.couleurPrincipale}; background: #fff; }
    #bla-send {
      width: 40px; height: 40px; border-radius: 50%;
      background: ${CONFIG.couleurPrincipale}; border: none;
      cursor: pointer; display: flex; align-items: center; justify-content: center;
      flex-shrink: 0; transition: background 0.2s, opacity 0.2s;
    }
    #bla-send:hover:not(:disabled) { background: ${CONFIG.couleurHover}; }
    #bla-send:disabled { opacity: 0.4; cursor: not-allowed; }
    #bla-send svg { width: 17px; height: 17px; fill: #fff; }

    /* ── Responsive mobile (95% des utilisatrices) ─── */
    @media (max-width: 480px) {
      /* Fenêtre presque plein écran */
      #bla-window {
        right: 0; left: 0; bottom: 0;
        width: 100%; max-width: 100%;
        height: 88vh; max-height: 88vh;
        border-radius: 20px 20px 0 0;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
      /* Bouton plus accessible */
      #bla-toggle {
        bottom: 16px; right: 16px;
        width: 56px; height: 56px;
      }
      /* Texte lisible sans zoom */
      .bla-bubble { font-size: 15px !important; padding: 12px 16px !important; }
      /* Cartes en carrousel sur mobile */
      .bla-cards-row { max-width: calc(100vw - 32px); }
      .bla-card { width: 135px; }
      .bla-card-img-wrapper { height: 145px; }
      /* Input plus grand pour les doigts */
      #bla-input { font-size: 16px !important; } /* 16px évite le zoom auto iOS */
      #bla-send { width: 44px; height: 44px; }
      /* Pills suggestions adaptées */
      .bla-suggestion { font-size: 13px; padding: 8px 14px; }
      /* En-tête compact */
      #bla-header { padding: 12px 16px; }
      /* Zone input avec plus d'espace */
      #bla-input-zone { padding: 10px 12px 16px; }
    }
  `;
  document.head.appendChild(style);

  // ─── Structure HTML ──────────────────────────────────────────────
  const conteneur = document.createElement('div');
  conteneur.id = 'bla-chatbot';
  conteneur.innerHTML = `
    <!-- Bouton flottant -->
    <button id="bla-toggle" aria-label="Ouvrir le chat">
      <svg id="bla-icon-chat" viewBox="0 0 24 24"><path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"/></svg>
      <svg id="bla-icon-close" viewBox="0 0 24 24" style="display:none"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
      <span id="bla-badge">1</span>
    </button>

    <!-- Fenêtre de chat -->
    <div id="bla-window" role="dialog" aria-label="Chat ByLesAudacieuses">
      <div id="bla-header">
        <div id="bla-avatar"><img src="https://bylesaudacieuses.com/cdn/shop/files/By_Les_Audacieuses_01d60566-f347-4e9b-991c-012d85912d03.png" alt="By Les Audacieuses" onerror="this.style.display='none'"></div>
        <div id="bla-header-info">
          <strong>${CONFIG.sousTitre}</strong>
        </div>
        <button id="bla-close" aria-label="Fermer">✕</button>
      </div>

      <div id="bla-messages" role="log" aria-live="polite"></div>

      <div id="bla-suggestions"></div>

      <div id="bla-input-zone">
        <textarea id="bla-input" placeholder="Écris ton message..." rows="1" aria-label="Message"></textarea>
        <button id="bla-send" aria-label="Envoyer" disabled>
          <svg viewBox="0 0 24 24"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>
        </button>
      </div>
    </div>
  `;
  document.body.appendChild(conteneur);

  // ─── Références DOM ──────────────────────────────────────────────
  const toggle = document.getElementById('bla-toggle');
  const fenetre = document.getElementById('bla-window');
  const fermer = document.getElementById('bla-close');
  const messages = document.getElementById('bla-messages');
  const input = document.getElementById('bla-input');
  const boutonEnvoyer = document.getElementById('bla-send');
  const suggestions = document.getElementById('bla-suggestions');
  const badge = document.getElementById('bla-badge');
  const iconChat = document.getElementById('bla-icon-chat');
  const iconClose = document.getElementById('bla-icon-close');

  // ─── Fonctions utilitaires ───────────────────────────────────────

  function ajouterMessage(texte, role) {
    const div = document.createElement('div');
    div.className = 'bla-msg ' + role;

    if (role === 'bot') {
      // Parser le texte pour trouver les marqueurs {{PRODUIT:clé}} et {{PLANITY_RDV}}
      const segments = parseContenuMessage(texte);

      // Construire le texte pur (sans marqueurs)
      let textePur = '';
      const cartesARendre = [];
      let afficherPlanity = false;

      segments.forEach(function (seg) {
        if (seg.type === 'text') {
          textePur += seg.content;
        } else if (seg.type === 'produit' && CATALOGUE[seg.cle]) {
          cartesARendre.push(seg.cle);
        } else if (seg.type === 'planity') {
          afficherPlanity = true;
        }
      });

      // Bulle texte (seulement si texte non vide)
      const texteTrimmed = textePur.trim();
      if (texteTrimmed) {
        const bubble = document.createElement('div');
        bubble.className = 'bla-bubble';
        // Filet de sécurité : si l'IA renvoie un lien au format Markdown
        // [texte](url) au lieu du HTML demandé, on le convertit quand même
        // en vrai lien cliquable — évite d'afficher un lien mort en texte brut.
        const texteAvecLiens = texteTrimmed.replace(
          /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
          '<a href="$2" target="_blank" rel="noopener">$1</a>'
        );
        bubble.innerHTML = texteAvecLiens.replace(/\n/g, '<br>');
        div.appendChild(bubble);
      }

      // Bouton Planity RDV
      if (afficherPlanity) {
        div.appendChild(creerBoutonPlanity());
      }

      // Cartes produits (max 5)
      if (cartesARendre.length > 0) {
        const row = document.createElement('div');
        row.className = 'bla-cards-row';
        cartesARendre.slice(0, 6).forEach(function (cle) {
          const carte = creerCarteElement(cle);
          row.appendChild(carte);
        });
        div.appendChild(row);
      }

    } else {
      // Message utilisateur — rendu simple
      const bubble = document.createElement('div');
      bubble.className = 'bla-bubble';
      bubble.innerHTML = texte.replace(/\n/g, '<br>');
      div.appendChild(bubble);
    }

    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
    return div;
  }

  function afficherTyping() {
    const div = document.createElement('div');
    div.className = 'bla-msg bot bla-typing';
    div.innerHTML = `<div class="bla-bubble"><div class="bla-dots"><span></span><span></span><span></span></div></div>`;
    div.id = 'bla-typing-indicator';
    messages.appendChild(div);
    messages.scrollTop = messages.scrollHeight;
  }

  function supprimerTyping() {
    const indicator = document.getElementById('bla-typing-indicator');
    if (indicator) indicator.remove();
  }

  function afficherSuggestions(liste) {
    suggestions.innerHTML = '';
    liste.forEach(function (texte) {
      const btn = document.createElement('button');
      btn.className = 'bla-suggestion';
      btn.textContent = texte;
      btn.addEventListener('click', function () {
        envoyerMessage(texte);
        suggestions.innerHTML = '';
      });
      suggestions.appendChild(btn);
    });
  }

  function ouvrirFenetre() {
    estOuvert = true;
    fenetre.classList.add('ouvert');
    iconChat.style.display = 'none';
    iconClose.style.display = 'block';
    badge.style.display = 'none';
    // Ne pas auto-focaliser sur mobile — le clavier masquerait les suggestions
    if (window.innerWidth > 480) { input.focus(); }

    // Message d'accueil à la première ouverture
    if (historique.length === 0) {
      ajouterMessage(CONFIG.messageAccueil, 'bot');
      afficherSuggestions(CONFIG.suggestionsInitiales);
    }
  }

  function fermerFenetre() {
    estOuvert = false;
    fenetre.classList.remove('ouvert');
    iconChat.style.display = 'block';
    iconClose.style.display = 'none';
  }

  // ─── Envoi de message ────────────────────────────────────────────
  async function envoyerMessage(texte) {
    const contenu = (texte || input.value).trim();
    if (!contenu || enAttente) return;

    // Vider l'input
    input.value = '';
    input.style.height = 'auto';
    boutonEnvoyer.disabled = true;
    suggestions.innerHTML = '';

    // Afficher message utilisateur
    ajouterMessage(contenu, 'user');
    historique.push({ role: 'user', content: contenu });

    // Indicateur de saisie
    enAttente = true;
    afficherTyping();

    // Réponse preset (suggestions vedettes) — pas d'appel API
    if (REPONSES_PRESET[contenu]) {
      await new Promise(r => setTimeout(r, 400)); // légère pause naturelle
      supprimerTyping();
      ajouterMessage(REPONSES_PRESET[contenu], 'bot');
      historique.push({ role: 'assistant', content: REPONSES_PRESET[contenu] });
      enAttente = false;
      if (SUGGESTIONS_APRES_PRESET[contenu]) {
        afficherSuggestions(SUGGESTIONS_APRES_PRESET[contenu]);
      }
      return;
    }

    try {
      const reponse = await fetch(CONFIG.apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: historique }),
      });

      supprimerTyping();

      if (!reponse.ok) throw new Error('Erreur réseau');

      const data = await reponse.json();
      const texteBot = data.reply || 'Désolée, je n\'ai pas pu répondre. Réessaie dans un moment ! 💛';

      ajouterMessage(texteBot, 'bot');
      historique.push({ role: 'assistant', content: texteBot });

      if (!estOuvert) {
        badge.style.display = 'flex';
      }

    } catch (err) {
      supprimerTyping();
      ajouterMessage('Oups, une erreur s\'est produite. Vérifie ta connexion et réessaie ! 💛', 'bot');
      console.error('Erreur chatbot:', err);
    }

    enAttente = false;
  }

  toggle.addEventListener('click', function () {
    estOuvert ? fermerFenetre() : ouvrirFenetre();
  });

  fermer.addEventListener('click', fermerFenetre);

  input.addEventListener('input', function () {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 100) + 'px';
    boutonEnvoyer.disabled = input.value.trim().length === 0;
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      envoyerMessage();
    }
  });

  boutonEnvoyer.addEventListener('click', function () { envoyerMessage(); });

  // Afficher le badge apres 3s pour attirer l'attention (premiere visite)
  setTimeout(function () {
    if (!estOuvert) {
      badge.style.display = 'flex';
    }
  }, 3000);

})();